export default __webpack_public_path__ + "static/media/bullet.743350d8.png";